module.exports = __webpack_public_path__ + "static/media/how-we-do.8c9ab882.jpg";